<template>
  <div class="w-100 p-4">
    <i class="el-icon-ice-cream d-block h1 font-color-primary"></i>
    <vue-typer
      class="font-weight-bold font-color-primary"
      erase-style="select-all"
      initial-action="erasing"
      :text="text"
    />
  </div>
</template>

<script>
export default {
  name: 'NoResults',
  components: {},
  props: {
    text: {
      type: String,
      default: 'Sorry, nothing found',
    },
  },
  mounted() {},
  destroyed() {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style scoped></style>
